import React, { useEffect } from 'react';
import { getDefaulAudioSource } from '../../audio/routing';
import {
    HorizontalNoteContainer,
    NoteRangeType
} from '../../model/containers';
import { TrackColor } from '../../render/trackColor';
import { CaretController } from '../../utils/ScrollController';
import {
    RydExternalMidiInstrument,
    RydInstrument,
    RydSFInstrument,
    RydVirtualInstrument
} from '../../model/instrument';
import { useMidiAccessStore } from '../../stores/MidiAccessStore';
import { RollIOControls } from '../dialogs/RollIOControls';
import RydRollHeaderGroup from '../widgets/RydRollHeaderGroup';
import { TonalityHighlightToggle } from '../dialogs/TonalityHighlightToggle';
import { TrackColorPicker } from '../pickers/TrackColorPicker';
import NoteRangeSelector from '../pickers/NoteRangeSelector';
import { RydCollapseControlButton } from '../widgets/RydCollapseControlButton';
import { RydTrack } from '../../model/tracks';
import { TrackNameDialog } from '../dialogs/TrackNameDialog';
import {
    useSetWorkspaceUIState,
    useWorkspaceComputedContextFrame,
    useWorkspaceUIState
} from '../../stores/WorkspaceStore';
import { TrackHeader } from './TrackHeader';
import { RydInputSource } from '../../audio/input';


export function PianoRollInfoHeader({
    hnc,
    track,
    setTrack,
    noteRange,
    readonly,
    collapsed,
    toggleSheetVisibilityCB,
    tonalityHighlightVisible,
    toggleTonalityHighlight,
    updateNoteRangeCB,
    setCollapsed,
    trackColor,
    setTrackColor,
    caretController,
    updateHNCCB,
    trackInstrument,
    setTrackInstrument,
    inputSource = getDefaulAudioSource(),
    setInputSource,
}: {
    hnc: HorizontalNoteContainer,
    track: RydTrack,
    setTrack: (track: RydTrack) => void,
    noteRange: NoteRangeType,
    readonly: boolean,
    collapsed: boolean,
    toggleSheetVisibilityCB: () => void,
    tonalityHighlightVisible: boolean,
    toggleTonalityHighlight: () => void,
    updateNoteRangeCB: (noteRange: NoteRangeType) => void,
    setCollapsed: (boolean) => void,
    trackColor: TrackColor.Color,
    setTrackColor: (color: TrackColor.Color) => void,
    caretController?: CaretController,
    updateHNCCB?: (hnc: HorizontalNoteContainer) => void,
    trackInstrument?: RydInstrument,
    setTrackInstrument?: (instrument?: RydInstrument) => void,
    inputSource? : RydInputSource,
    setInputSource?: (source: RydInputSource) => void,
}) {

    const midiAccessStore = useMidiAccessStore();
    const computedContextFrame = useWorkspaceComputedContextFrame();
    const workspaceUiState = useWorkspaceUIState();
    const setWorkspaceUIState = useSetWorkspaceUIState();

    useEffect(() => {
        if (!trackInstrument) return;
        if (trackInstrument instanceof RydVirtualInstrument) {

        } else if (trackInstrument instanceof RydSFInstrument) {

        } else if (trackInstrument instanceof RydExternalMidiInstrument && midiAccessStore.midiAccess) {
            // FIXME this should happen when setting the instrument
            trackInstrument.midiOutput = midiAccessStore.midiAccess.outputs.get(trackInstrument.midiSink.id);
        }
    }, [trackInstrument]);

    return (
        <TrackHeader>
            <RydRollHeaderGroup>
                {readonly ? " (readonly) - " : ""}
                <TrackNameDialog
                    label="Track Name"
                    value={track?.name || 'Unnamed Track'}
                    setValue={(name) => {
                        console.log('set name', name, track);
                        if (track && name) {
                            track.name = name;
                            setTrack({ ...track });
                        }
                    }} />
                <TrackColorPicker
                    color={trackColor}
                    onColorSelect={setTrackColor}
                />
            </RydRollHeaderGroup>
            <RollHeaderPinnedRegion>
                <RydCollapseControlButton collapsed={collapsed} setCollapsed={setCollapsed} />
            </RollHeaderPinnedRegion>
            <br />
            <RydRollHeaderGroup>
                <RollIOControls
                    track={track}
                    setSourceCB={setInputSource}
                    source={inputSource}
                    trackInstrument={trackInstrument}
                    setTrackInstrument={setTrackInstrument}
                    insertNoteCB={(track, start, note, duration, velocity) => {
                        const tick = start;
                        hnc.put(tick, {
                            step: tick,
                            payload: note,
                            duration,
                            velocity
                        });
                        updateHNCCB?.(hnc);
                    }}
                />
            </RydRollHeaderGroup>

            {!collapsed &&
                <>
                    <RydRollHeaderGroup>
                        {!collapsed &&
                            <NoteRangeSelector
                                noteRange={noteRange}
                                updateNoteRangeCB={updateNoteRangeCB}
                                getEffectiveNoteRange={() => hnc.getNoteRange()}
                            />}
                        <TonalityHighlightToggle
                            contextFrame={computedContextFrame}
                            tonalityHighlightVisible={tonalityHighlightVisible}
                            setTonalityHighlightVisible={toggleTonalityHighlight} />
                    </RydRollHeaderGroup>
                </>
            }
        </TrackHeader>
    );
}

export function RollHeaderPinnedRegion({ children }) {
    return (<div style={{
        display: 'inline-block',
        right: '0px',
        position: 'absolute',
    }}>{children}</div>);
}